.primaryStars {
  --star-rating-fill-color: var(--colors-primary-main);
}

@media (--reefer-media-tablet-min) {
  .submit {
    width: 50%;
  }
}
